import React from "react";
import queryString from "query-string";
import { useQuery, useMutation } from "react-query";
import { Button, Header, Segment, Dimmer, Loader, List, Checkbox } from "semantic-ui-react";
import {
  subscribeEmailGroup,
  unsubscribeEmailGroup,
  subscribeAllEmails,
  unsubscribeAllEmails,
  getEmailSubscriptionGroups,
} from "../../../queries/communications";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

export const Unsubscribe = (props: any) => {
  const { email } = queryString.parse(props.location.search);
  const networkHeaders = useNetworkHeaders();
  const subscriptionsQuery = useQuery(
    ["communications.subscriptions", email],
    getEmailSubscriptionGroups(networkHeaders),
  );
  const [unsubscribeAll] = useMutation(unsubscribeAllEmails(networkHeaders, email as string));
  const [subscribeAll] = useMutation(subscribeAllEmails(networkHeaders));
  const [unsubscribeGroup] = useMutation(unsubscribeEmailGroup(networkHeaders, email as string));
  const [subscribeGroup] = useMutation(subscribeEmailGroup(networkHeaders, email as string));

  if (subscriptionsQuery.isLoading) {
    return (
      <Dimmer active>
        <Loader />
      </Dimmer>
    );
  }
  if (subscriptionsQuery.data?.response?.status === 404) {
    return (
      <Segment basic>
        <Header>{`Having second thoughts? We'd love to have you join us!`}</Header>
        <Button
          onClick={async () => {
            await subscribeAll(email as string);
            subscriptionsQuery.refetch();
          }}
        >
          Subscribe
        </Button>
      </Segment>
    );
  }

  const { data } = subscriptionsQuery.data?.json;
  return (
    <Segment basic>
      <Header>
        <Header.Content>
          {`Manage Your Subscriptions`}
          <Header.Subheader>For {email}</Header.Subheader>
        </Header.Content>
      </Header>
      <List>
        <List.Item>
          <List.List>
            {data.map((subscription: any) => {
              return (
                <List.Item key={subscription.id}>
                  <Checkbox
                    label={subscription.attributes.name}
                    checked={subscription.attributes.subscribed}
                    onClick={async (e, { checked }) => {
                      await (checked
                        ? subscribeGroup({ id: subscription.id })
                        : unsubscribeGroup({ id: subscription.id }));
                      subscriptionsQuery.refetch();
                    }}
                  />
                </List.Item>
              );
            })}
          </List.List>
        </List.Item>
        <List.Item>
          <Button
            onClick={async (e, { checked }) => {
              await (checked ? subscribeAll() : unsubscribeAll());
              subscriptionsQuery.refetch();
            }}
          >
            Unsubscribe From All
          </Button>
        </List.Item>
      </List>
    </Segment>
  );
};
